<template>
  <div class="mb-5">
    <ClientDrugSchedulePager
      :date="date"
      v-on:change-date="changeDate" />

    <ClientDrugScheduleList
      :date="date"
      :prescriptions="data"
      :times="times" />
  </div>
</template>

<script>
import ClientDrugSchedulePager from './schedule/Pager';
import ClientDrugScheduleList from './schedule/List';
import calculateDaysCount from '../../../utils/calculateDaysCount';
import formatDate from '../../../utils/formatDate';
import {MS_IN_DAY} from '../../../constants';

export default {
  name: 'ClientDrugSchedule',

  props: ['prescriptions', 'times'],

  components: {ClientDrugScheduleList, ClientDrugSchedulePager},

  data() {
    return {
      date: new Date(),
    };
  },

  computed: {
    data() {
      return this.prescriptions.filter(prescription => {
        if (prescription.startedAt === null) {
          return false;
        }

        const {startDate, finishDate, startedAt} = prescription;
        const daysPrescribed = calculateDaysCount(startDate, finishDate);
        const endDate = new Date(startedAt.getTime() + (daysPrescribed - 1) * MS_IN_DAY);
        const from = formatDate(startedAt, 'ymd');
        const to = formatDate(endDate, 'ymd');
        const day = formatDate(this.date, 'ymd');

        return from <= day && day <= to;
      });
    },
  },

  methods: {
    changeDate(date) {
      this.date = date;
    },
  }
};
</script>
